import Vue from 'vue'

export default ({ store, $axios, $cookies }, inject) => {
  if (Object.prototype.hasOwnProperty.call(Vue, '$log')) {
    return
  }
  const eventBuffer = []
  let timer = null

  function sendEvents() {
    if (eventBuffer.length > 0) {
      const events = [...eventBuffer]
      eventBuffer.length = 0
      $axios.post('/events', { events }).catch(() => {
        console.error('error sending event logs')
      })
    }
  }

  const logFunction = ({ name, properties }) => {
    const { orderId } = store.state.order.order
    const userId = $cookies.get('ls_lb_uid') || ''
    const event = {
      name,
      properties: {
        userId,
        orderId,
        ...properties,
      },
      time: new Date().toISOString(),
    }
    eventBuffer.push(event)
    if (!timer) {
      timer = setInterval(sendEvents, 2000)
    }
  }

  inject('log', logFunction)

  // Make $log globally accessible for Pinia stores
  if (typeof process !== 'undefined' && process.server) {
    global.__NUXT_LOG__ = logFunction
  }
}
